import type { IconDefinition } from '../index.tsx';

export const iconCart: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCart',
  icon: [
    16,
    16,
    [],
    '',
    'M0 1V3H2.15287L2.98347 7.98361L2.01942 12.8039C2.00612 12.8704 1.99972 12.9375 2 13.0041C2.00141 13.3451 2 13.6507 2 14C2 15.1046 2.89543 16 4 16C5.10457 16 6 15.1046 6 14H10C10 15.1046 10.8954 16 12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12H4.2198L4.6198 10H15V1H0Z',
  ],
};
